module.exports = __webpack_public_path__ + "static/media/login-image.5be8fea9.jpg";